import axios from "axios";
import FormData  from "form-data";
import ConfigurationManager from "../configuration/ConfigurationManager";
import {
  FLIGHT_APIS,
  FLIGHT_PASSENGER_APIS,
  IDENTITY_APIs,
  PASSENGER_APIS,
} from "../constants";
import { Auth } from "aws-amplify";
import ApiManager from "./ApiManager";
import Utility from "./Utility";
import { constants } from "buffer";
import { APIs } from "./APIs";
import { CheckMultiLoginFun } from "../CheckMultiLogin/CheckMultiLoginFun";

class SafeairApiManager {
  constructor() {
    this.configurationManager = ConfigurationManager;

    this.apiManager = new ApiManager();
    axios.interceptors.request.use(
      async (config) => {
        const { origin } = new URL(config.url);
        const allowedOrigins = [config.url];
        const token = (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken();
        if (token != null && !Utility.isTokenExpired(token)) {
          config.headers.authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
  //commit
  async login(username, password, onLogin) {
    let configuration = await this.configurationManager.getConfiguration();
    this.apiManager
      .post(
        configuration["api_base_url"] + IDENTITY_APIs.login,
        {
          username,
          password,
        },
        {
          api_key: undefined,
          token: undefined,
        }
      )
      .then((res) => {
        if (res.status == 200) {
          onLogin(res.data.token);
        } else {
          onLogin(undefined);
        }
      })
      .catch((res) => {
        onLogin(undefined);
      });
  }

  /*

    Flights

  */
  // List flights
  async listAllFlights(onResponse) {
    let configuration = await this.configurationManager.getConfiguration();
    this.apiManager
      .get(configuration["api_base_url"] + FLIGHT_APIS.ListFlights)
      .then((res) => {
        onResponse(res.data);
      })
      .catch((res) => {
        onResponse(undefined);
      });
  }

  /*

    Passengers

  */
  //List passenger
  async listPassengers(onResponse) {
    let configuration = await this.configurationManager.getConfiguration();

    this.apiManager
      .get(configuration["api_base_url"] + PASSENGER_APIS.ListPassengers)
      .then((res) => {
        onResponse(res.data);
      })
      .catch((res) => {
        onResponse(undefined);
      });
  }

  /*
  
    Flight-Passenger

  */
  //List flight-passengers by flightId
  async listPassengerInFlight(flightId, onResponse) {
    let configuration = await this.configurationManager.getConfiguration();

    this.apiManager
      .get(
        configuration["api_base_url"] +
          FLIGHT_PASSENGER_APIS.ListAllFlightPassengersByFlightId.replace(
            "$flightId",
            flightId
          )
      )
      .then((res) => {
        onResponse(res.data);
      })
      .catch((res) => {
        onResponse(undefined);
      });
  }

  async callWithRetry(fn, params, depth = 0) {
    try {
      // if needed extract
      return await fn(params);
    } catch (e) {
      if (depth > 7) {
        throw e;
      }
      await this.wait(2 ** depth * 10);
      return this.callWithRetry(fn, params, depth + 1);
    }
  }

  async wait(time) {
    return await new Promise((res, rej) => {
      setTimeout(() => {
        res();
      }, time);
    });
  }

  async invoke({ api, parameters, body }) {
    let endpointRegister = localStorage.getItem("isRegister");
    if (api.API.indexOf("userDeviceToken") == -1 && endpointRegister == 1) {
        CheckMultiLoginFun();
    }
    let accessToken = (await Auth.currentSession())
      .getAccessToken()
      .getJwtToken();

    let url = APIs.BASE_URL + api.API;

    let headers = {
      ...(accessToken !== null && {
        Authorization: `Bearer ${accessToken}`,
      }),
    };

    if (parameters !== null) {
      Object.keys(parameters).forEach((item, index) => {
        url = url.replace(`{${item}}`, parameters[item]);
      });
    }

    return await axios({
      method: api.METHOD,
      url,
      ...(body != null && { data: body }),
      // ...(url.includes("medicalKit?exportKitstoPdf=")) ? { responseType: 'blob' } : {},
      ...(url.includes("medicalKit?exportKitstoPdf=") || api.responseType === 'blob' ? { responseType: 'blob' } : {}),
      //headers,
    });
  }



  async createMedical({ api, parameters, body }) {
    let endpointRegister = localStorage.getItem("isRegister");
    if (api.API.indexOf("userDeviceToken") == -1 && endpointRegister == 1) {
        CheckMultiLoginFun();
    }
    let accessToken = (await Auth.currentSession())
      .getAccessToken()
      .getJwtToken();

    let url = APIs.BASE_URL + api.API;

    let headers = {
      // ...(accessToken !== null && {
      //   Authorization: `Bearer ${accessToken}`,
      // }),
      "Content-Type": "application/json",
    };

    if (parameters !== null) {
      Object.keys(parameters).forEach((item, index) => {
        url = url.replace(`{${item}}`, parameters[item]);
      });
    }

    return await axios({
      method: api.METHOD,
      url,
      ...(body != null && { data: body }),
      ...(url.includes("medicalKit?exportKitstoPdf=")) ? { responseType: 'blob' } : {},
      headers,
    });
  }

  async saveSubscription({ api, parameters, body }) {
    try {
      let accessToken = (await Auth.currentSession())
        .getAccessToken()
        .getJwtToken();
  
      let url = APIs.BASE_URL + api.API;
  
      let headers = {
        "Content-Type": "application/json",
        // ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      };
  
      if (parameters !== null) {
        Object.keys(parameters).forEach((item) => {
          url = url.replace(`{${item}}`, parameters[item]);
        });
      }
  
      return await axios({
        method: api.METHOD,
        url,
        data: body,
        headers,
      });
    } catch (error) {
      console.error("Error in saveSubscription:", error);
      throw error;
    }
  }

  async getSubscriptionByOrgId({ api, parameters }) {
    try {
      const accessToken = (await Auth.currentSession())
        .getAccessToken()
        .getJwtToken();
  
      let url = APIs.BASE_URL + api.API;
  
      // Replace the {orgId} in the URL
      if (parameters !== null) {
        Object.keys(parameters).forEach((key) => {
          url = url.replace(`{${key}}`, parameters[key]);
        });
      }
  
      const headers = {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${accessToken}`,
      };
  
      const response = await axios({
        method: api.METHOD,
        url,
        headers,
      });
  
      return response.data;
    } catch (error) {
      console.error("Error fetching subscription by orgId:", error);
      throw error;
    }
  }
  
  async getallSubscriptionByOrgId({ api, parameters }) {
    try {
      const accessToken = (await Auth.currentSession())
        .getAccessToken()
        .getJwtToken();
  
      let url = APIs.BASE_URL + api.API;
  
      // Replace the {orgId} in the URL
      if (parameters !== null) {
        Object.keys(parameters).forEach((key) => {
          url = url.replace(`{${key}}`, parameters[key]);
        });
      }
  
      const headers = {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${accessToken}`,
      };
  
      const response = await axios({
        method: api.METHOD,
        url,
        headers,
      });
  
      return response.data;
    } catch (error) {
      console.error("Error fetching subscription by orgId:", error);
      throw error;
    }
  }

  async getAllSubscriptions({ api, queryParams = {} }) {
    try {
      const accessToken = (await Auth.currentSession())
        .getAccessToken()
        .getJwtToken();
  
      let url = APIs.BASE_URL + api.API;
  
      // Add query parameters to URL if present
      const queryString = new URLSearchParams(queryParams).toString();
      if (queryString) {
        url += `?${queryString}`;
      }
  
      const headers = {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${accessToken}`,
      };
  
      const response = await axios({
        method: api.METHOD,
        url,
        headers,
      });
  
      return response.data;
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      throw error;
    }
  }

  //subscription
  

  async invokenew({ api, parameters, body }) {

    try{
    let accessToken = (await Auth.currentSession())
      .getAccessToken()
      .getJwtToken();

    let url = APIs.BASE_URL + api.API;
console.log(accessToken);
let headers = {
};
    // let headers = {
    //   ...(accessToken !== null && {
    //     Authorization: `Bearer ${accessToken}`,
    //   }),
    // };

    if (parameters !== null) {
      Object.keys(parameters).forEach((item, index) => {
        url = url.replace(`{${item}}`, parameters[item]);
      });
    }

    const formData = new FormData();

    if (body) {
      // Add fields to the FormData object
      for (const key of Object.keys(body)) {
        console.log(key);
        formData.append(key, body[key]);
      }
    }
    headers['Content-Type'] = 'multipart/form-data';
    headers['Authorization'] = 'Bearer '+accessToken;
    const response = await axios({
      method: api.METHOD,
      url,
      data: formData,
      headers,
    });
    return response;
  }catch (error) {
    // Handle the error (e.g., log it, re-throw, or return an error response)
    console.error('Error in invoke:', error);
    throw error; // Re-throw the error to handle it further up the call stack
  }

  
  }

  


  
}

export default new SafeairApiManager();
